import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import { validateEnvironment } from './utils/validation/environmentValidator';

// Disable React Router future flag warning
window.history.scrollRestoration = 'manual';

// Validate environment before mounting app
if (validateEnvironment()) {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  // Show error UI
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-family: system-ui;">
        <div style="text-align: center; padding: 20px;">
          <h1 style="color: #ef4444;">Configuration Error</h1>
          <p>The application could not be initialized due to missing configuration.</p>
          <p>Please contact support if this issue persists.</p>
        </div>
      </div>
    `;
  }
}